import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { string, func, bool, number, object } from 'prop-types';
import { currencyFormatter } from '@magalu/stereo-ui-utils';
import { PriceRange } from '../../molecules';
import FilterItemContainer from '../FilterItemContainer';

const FilterItemPrice = _ref => {
  let {
    fullScreen,
    label,
    position,
    onApply,
    min,
    max,
    selectedMin,
    selectedMax,
    item
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["fullScreen", "label", "position", "onApply", "min", "max", "selectedMin", "selectedMax", "item"]);

  return /*#__PURE__*/React.createElement(FilterItemContainer, _extends({
    id: "filter-item-price-container",
    position: position,
    label: label,
    fullScreen: fullScreen,
    filterSelected: selectedMin || selectedMax ? `${currencyFormatter({
      value: selectedMin
    })} - ${currencyFormatter({
      value: selectedMax
    })}` : undefined
  }, props), /*#__PURE__*/React.createElement(PriceRange, {
    min: min,
    max: max,
    initialMin: selectedMin,
    initialMax: selectedMax,
    onApply: onApply,
    item: item
  }));
};

FilterItemPrice.defaultProps = {
  onApply: () => {},
  onClick: () => {},
  item: {}
};
process.env.NODE_ENV !== "production" ? FilterItemPrice.propTypes = {
  label: string.isRequired,
  position: number,
  fullScreen: bool,
  onApply: func,
  onClick: func,
  min: number.isRequired,
  max: number.isRequired,
  selectedMin: number,
  selectedMax: number,
  item: object
} : void 0;
export default FilterItemPrice;